/**
 * 图层处理器索引文件
 * 用于统一导出所有图层处理器
 *
 * 注意：图层处理器已经重构，使用了baseProcessor.ts中的通用处理逻辑
 * 减少了代码重复，提高了可维护性，详见baseProcessor.ts
 */

import { dynamicBeeSwarm } from './scatter/dynamicBeeSwarm';
import { dynamicBubble } from './scatter/dynamicBubble';
import { scatter } from './scatter/scatter';
import { scatter3D } from './scatter/scatter3D';
import { bar } from './bar/bar';
import { bar3D } from './bar/bar3D';
import { barDistribution } from './bar/barDistribution';
import { chainChangeBar } from './bar/chainChangeBar';
import { contrastDoubleBar } from './bar/contrastDoubleBar';
import { dynamicRankingHorizontalBar } from './bar/dynamicRankingHorizontalBar';
import { dynamicRankingTwoWayHorizontalBar } from './bar/dynamicRankingTwoWayHorizontalBar';
import { groupedStackedBar } from './bar/groupedStackedBar';
import { polarBar } from './bar/polarBar';
import { positiveAndNegativeDoubleIndicatorSumBar } from './bar/positiveAndNegativeDoubleIndicatorSumBar';
import { rankingHorizontalBar } from './bar/rankingHorizontalBar';
import { rankingTwoWayHorizontalBar } from './bar/rankingTwoWayHorizontalBar';
import { shadowBar } from './bar/shadowBar';
import { stackBoardBar } from './bar/stackBoardBar';
import { waterfall } from './bar/waterfall';
import { bandedIntervalTrendLine } from './line/bandedIntervalTrendLine';
import { dynamicLine } from './line/dynamicLine';
import { dynamicRankingLine } from './line/dynamicRankingLine';
import { line } from './line/line';
import { markerLine } from './line/markerLine';
import { positiveAndNegativeDoubleIndicatorComparisonLine } from './line/positiveAndNegativeDoubleIndicatorComparisonLine';
import { rankingLine } from './line/rankingLine';
import { doublePie } from './pie/doublePie';
import { dynamicPie } from './pie/dynamicPie';
import { pie } from './pie/pie';
import { gauge } from './gauge/gauge';
import { multiIndicatorRingGauge } from './gauge/multiIndicatorRingGauge';
import { funnel } from './funnel/funnel';
import { radar } from './radar/radar';
import { tree } from './tree/tree';
import { drillableTreemap } from './treeMap/drillableTreemap';
import { dynamicTreeMap } from './treeMap/dynamicTreeMap';
import { treeMap } from './treeMap/treeMap';
import { dynamicSankey } from './other/dynamicSankey';
import { dynamicVoronoi } from './other/dynamicVoronoi';
import { wordCloud } from './other/wordCloud';
import { multiTable } from './text/multiTable';
import { summaryText } from './text/summaryText';
import { text } from './text/text';
import { timeLine } from './text/timeLine';
import { hxKLine } from './hxKLine/hxKLine';
import { hxKLineAndBar } from './hxKLine/hxKLineAndBar';
import { hxKLineAndDynamicLine } from './hxKLine/hxKLineAndDynamicLine';
import { hxKLineAndMultiIndicatorLine } from './hxKLine/hxKLineAndMultiIndicatorLine';
import { hxKLineAndTag } from './hxKLine/hxKLineAndTag';

// 处理器映射表
export const layerProcessors = {
  dynamicBeeSwarm,
  dynamicBubble,
  scatter,
  scatter3D,
  bar,
  bar3D,
  barDistribution,
  chainChangeBar,
  contrastDoubleBar,
  dynamicRankingHorizontalBar,
  dynamicRankingTwoWayHorizontalBar,
  groupedStackedBar,
  polarBar,
  positiveAndNegativeDoubleIndicatorSumBar,
  rankingHorizontalBar,
  rankingTwoWayHorizontalBar,
  shadowBar,
  stackBoardBar,
  waterfall,
  bandedIntervalTrendLine,
  dynamicLine,
  dynamicRankingLine,
  line,
  markerLine,
  positiveAndNegativeDoubleIndicatorComparisonLine,
  rankingLine,
  doublePie,
  dynamicPie,
  pie,
  gauge,
  multiIndicatorRingGauge,
  funnel,
  radar,
  tree,
  drillableTreemap,
  dynamicTreeMap,
  treeMap,
  dynamicSankey,
  dynamicVoronoi,
  wordCloud,
  multiTable,
  summaryText,
  text,
  timeLine,
  hxKLine,
  hxKLineAndBar,
  hxKLineAndDynamicLine,
  hxKLineAndMultiIndicatorLine,
  hxKLineAndTag
};
